import React, { useMemo } from "react";
import { bpkbInsuranceInfo, exclusiveInsuranceInfo, smartphoneInsuranceInfo, vehicleInsuranceInfo } from "./constants";

const InsuranceTab = ({ data }) => {
  const { commonInfo, insuranceInfo } = data;

  const insuranceLabelList = useMemo(() => {
    const category = commonInfo?.productCategory?.toLowerCase();
    if (category === "car" || category === "bike") {
      return vehicleInsuranceInfo;
    } else if (category === "bpkb") {
      return bpkbInsuranceInfo;
    } else if (category === "smartphone") {
      return smartphoneInsuranceInfo;
    } else if (category === "other") {
      return exclusiveInsuranceInfo;
    }
  }, [commonInfo?.productCategory]);

  return (
    <div className="detail-bold-text">
      {Object.keys(insuranceLabelList).map((insuranceLabel) => {
        return (
          <div className="row detail-row">
            <div className="col-4">
              {insuranceLabelList[insuranceLabel].label}
            </div>
            <div className="col-md-auto">:</div>
            <div className="col">{insuranceInfo?.[insuranceLabel] || "-"}</div>
          </div>
        );
      })}
    </div>
  );
};

export default InsuranceTab;
